module.exports = __webpack_public_path__ + "img/suppy.d45668b6.png";